export const REPORT_PRINT_PREPARE_EVENT = 'analysis-report-prepare-print';

export function preserveReportMapPrintView(map: google.maps.Map, container: HTMLElement) {
    if (!container.closest('.analysis-report-print-area'))
        return;

    let camera: google.maps.CameraOptions | null = null;
    let restoreFrame = 0;
    const redraw = () => {
        if (!camera)
            return;
        window.google.maps.event.trigger(map, 'resize');
        map.moveCamera(camera);
    };
    const beforePrint = () => {
        cancelAnimationFrame(restoreFrame);
        const center = map.getCenter();
        const zoom = map.getZoom();
        if (!camera && center && zoom !== undefined)
            camera = { center: center.toJSON(), zoom, heading: map.getHeading(), tilt: map.getTilt() };
        redraw();
    };
    const afterPrint = () => {
        cancelAnimationFrame(restoreFrame);
        // Print media and the report shell can restore their sizes on separate frames.
        restoreFrame = requestAnimationFrame(() => {
            redraw();
            restoreFrame = requestAnimationFrame(() => {
                redraw();
                camera = null;
            });
        });
    };
    const preparePrint = (event: Event) => {
        if ((event as CustomEvent<HTMLElement>).detail.contains(container))
            beforePrint();
    };
    const printMedia = window.matchMedia('print');
    const printMediaChanged = (event: MediaQueryListEvent) => {
        if (event.matches)
            beforePrint();
        else
            afterPrint();
    };
    const observer = new ResizeObserver(redraw);
    observer.observe(container);
    printMedia.addEventListener('change', printMediaChanged);
    window.addEventListener(REPORT_PRINT_PREPARE_EVENT, preparePrint);
    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);

    return () => {
        observer.disconnect();
        cancelAnimationFrame(restoreFrame);
        printMedia.removeEventListener('change', printMediaChanged);
        window.removeEventListener(REPORT_PRINT_PREPARE_EVENT, preparePrint);
        window.removeEventListener('beforeprint', beforePrint);
        window.removeEventListener('afterprint', afterPrint);
    };
}
